/**
 * @param {string} teaserImage - teaserImage
 * @returns {string} teaserImage block HTML
 */
export default teaserImage =>
    `${
        teaserImage
            ? `
            <div class="teaser-image">
                ${teaserImage}
            </div>`
            : ''
    }`;
